import styled from 'styled-components'
import Dropzone from 'react-dropzone'

export const Upload = styled(Dropzone)`
  margin: 0;
  padding: 0;
  min-width: 0;
  min-height: 0;
  border: none;
  cursor: pointer;
`
